export default class Urls {

    static isImage(url) {
        return ['jpg', 'jpeg', 'png', 'webp', 'gif'].includes(this.ext(url));
    }

    static isVideo(url) {
        return ['mp4', 'mov'].includes(this.ext(url));
    }

    static isVideoFromGif(url) {
        return url.match(".animated.");
    }

    static isAudio(url) {
        return ['mp3'].includes(this.ext(url));
    }

    static ext(url) {
        return url.split(/[#?]/)[0].split('.').pop().trim();
    }

    static baseUrl(url) {
        return url.split('#').slice(0, 1)[0];
    }

    static hash(url) {
        let parts = url.split('#');
        if (parts.length > 1) {
            return parts.pop();
        }

        return null;
    }

    static getCurrentUrl() {
        return window.location.href;
    }

    static setQueryParamToUrl(urlToChange, param, value) {
        urlToChange = urlToChange ?? this.getCurrentUrl();
        const url = new URL(urlToChange);
        const params = url.searchParams;

        if (value === null || value === undefined || value === '') {
            params.delete(param);
        } else {
            params.set(param, value);
        }

        return url.toString();
    }

    static applyUpdatedUrl(param, value) {
        const newUrl = this.setQueryParamToUrl(this.getCurrentUrl(), param, value);
        window.history.replaceState(null, '', newUrl);
    }
}
